import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import Banner from '../components/Banner';

export default function Error() {
  return (
    <section>
      <Hero hero='errorHero'>
        <Banner title='404' subtitle='Page Not Found...'>
          <Link to='/' className='btn-primary'>
            Home
          </Link>
        </Banner>
      </Hero>
    </section>
  );
}
